import React, { useState, useEffect, useCallback } from 'react';
import { Typography, useTheme, useMediaQuery } from '@mui/material';
import vsDarkTheme from "../theme/vsDarkTheme";

const TypewriterHeader = ({ 
  title, 
  speed = 50, 
  delay = 0,
  onComplete = () => {}
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [hasCompleted, setHasCompleted] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleComplete = useCallback(() => {
    if (!hasCompleted) {
      setHasCompleted(true);
      onComplete();
    }
  }, [onComplete, hasCompleted]);

  useEffect(() => {
    if (delay > 0) {
      const delayTimer = setTimeout(() => {
        setIsTyping(true);
      }, delay);
      return () => clearTimeout(delayTimer);
    } else {
      setIsTyping(true);
    }
  }, [delay]);

  useEffect(() => {
    if (!isTyping || currentIndex >= title.length) {
      if (currentIndex >= title.length && !hasCompleted) {
        handleComplete();
      }
      return;
    }

    const timer = setTimeout(() => {
      setDisplayText(prev => prev + title[currentIndex]);
      setCurrentIndex(prev => prev + 1);
    }, speed);

    return () => clearTimeout(timer);
  }, [currentIndex, title, speed, isTyping, handleComplete, hasCompleted]);

  // Reset state when title changes
  useEffect(() => {
    setDisplayText('');
    setCurrentIndex(0);
    setIsTyping(false);
    setHasCompleted(false);
  }, [title]);

  return (
    <Typography 
      variant={isMobile ? "h5" : "h4"} 
      gutterBottom 
      sx={{ 
        color: vsDarkTheme.palette.primary.main,
        wordBreak: 'break-word'
      }}
    >
      function {displayText}
      {isTyping && currentIndex < title.length && (
        <span style={{ 
          borderRight: '2px solid #569cd6', 
          animation: 'blink 1s infinite',
          marginLeft: '2px'
        }} />
      )}
      <span style={{ color: vsDarkTheme.palette.secondary.main }}>()</span> <span style={{ color: vsDarkTheme.palette.comment.main }}>&#123;</span>
      <style>
        {`
          @keyframes blink {
            0%, 50% { border-color: #569cd6; }
            51%, 100% { border-color: transparent; }
          }
        `}
      </style>
    </Typography>
  );
};

export default TypewriterHeader;
